<template>
  <el-button @click="logout" size="mini" circle>
    <i class="icon iconfont icon-logout"></i>
  </el-button>
</template>

<script>
export default {
  name: 'LogoutButton',
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
      location.href = '/'
    },
  },
}
</script>
